import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import ReactDOM from 'react-dom';
import hoistStatics from 'hoist-non-react-statics';
var scrollHandlerBound = false;
var scrollCallbacks = [];
var timeout;
var lastId = 0;

var scrollHandler = function scrollHandler() {
  clearTimeout(timeout);
  timeout = setTimeout(function () {
    scrollCallbacks.forEach(function (_ref) {
      var fn = _ref.fn;
      return fn();
    });
  }, 50);
};

var CALLBACKS = {
  ON_ENTER: 'onDwellEnter',
  ON_LEAVE: 'onDwellLeave',
  ON_DWELL: 'onDwell'
};
var resetScrollStuff; // eslint-disable-line import/no-mutable-exports

if (__TEST__) {
  resetScrollStuff = function resetScrollStuff() {
    scrollCallbacks.length = 0;
    scrollHandlerBound = false;
    window.removeEventListener('scroll', scrollHandler, true);
    window.removeEventListener('resize', scrollHandler, true);
  };
}

export { resetScrollStuff };
export default (function (Component) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref2$dwellTime = _ref2.dwellTime,
      dwellTime = _ref2$dwellTime === void 0 ? 1000 : _ref2$dwellTime,
      callbacks = _objectWithoutProperties(_ref2, ["dwellTime"]);

  var klass =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(klass, _React$Component);

    function klass() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, klass);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(klass)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "onDwellScroll", function () {
        if (_this.inViewport()) {
          if (_this.wasInViewport !== true) {
            _this.triggerCallback(CALLBACKS.ON_ENTER);
          }

          if (!_this.dwellTimeout && !_this.wasInViewport) {
            _this.dwellTimeout = setTimeout(function () {
              _this.dwellTimeout = null;

              if (_this.inViewport()) {
                _this.triggerCallback(CALLBACKS.ON_DWELL);
              }
            }, dwellTime);
          }

          _this.wasInViewport = true;
        } else if (!_this.inViewport() && _this.wasInViewport !== false) {
          _this.triggerCallback(CALLBACKS.ON_LEAVE);

          _this.wasInViewport = false;
        }
      });

      _defineProperty(_assertThisInitialized(_this), "setComponentNode", function (cmp) {
        return _this.componentNode = cmp;
      });

      _defineProperty(_assertThisInitialized(_this), "inViewport", function () {
        if (_this.componentNode) {
          // eslint-disable-next-line react/no-find-dom-node
          var node = ReactDOM.findDOMNode(_this.componentNode);

          if (!node) {
            return false;
          }

          var rect = node.getBoundingClientRect(); // This implementation will trigger if at least one pixel of the element is in the viewport

          return rect.bottom > 0 && rect.right > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.left < (window.innerWidth || document.documentElement.clientWidth);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "triggerCallback", function (callbackName) {
        if (callbacks[callbackName]) {
          callbacks[callbackName]();
        }

        if (_this.componentNode && _this.componentNode[callbackName]) {
          _this.componentNode[callbackName]();
        }
      });

      return _this;
    }

    _createClass(klass, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!scrollHandlerBound) {
          scrollHandlerBound = true;
          window.addEventListener('scroll', scrollHandler, true);
          window.addEventListener('resize', scrollHandler, true);
        }

        scrollCallbacks.push({
          id: lastId += 1,
          fn: this.onDwellScroll
        });
        this.dwellScrollbackId = scrollCallbacks[scrollCallbacks.length - 1].id;
        this.wasInViewport = null;
        this.onDwellScroll();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this2 = this;

        scrollCallbacks = scrollCallbacks.filter(function (_ref3) {
          var id = _ref3.id;
          return id !== _this2.dwellScrollbackId;
        });

        if (scrollCallbacks.length === 0) {
          window.removeEventListener('scroll', scrollHandler, true);
          window.removeEventListener('resize', scrollHandler, true);
          scrollHandlerBound = false;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(Component, _extends({
          ref: this.setComponentNode
        }, this.props));
      }
    }]);

    return klass;
  }(React.Component);

  klass.displayName = "fiveEyes(".concat(Component.displayName || Component.name, ")");
  return hoistStatics(klass, Component);
});